import React, { Component } from "react";
import "./solicitud.css";
import Navbar from "../../componentes/navbar/navbar";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import { toast } from "react-toastify";
import { DatePicker } from "react-rainbow-components";
import { solicitudDetalle, apiVincular, apidesvincular, getListaNacionalidad } from "../../service/api";

import { getListaSolicitud, agregarSolicitud, editarSolicitud, eliminarSolicitud, getListaMoneda, ventasListaNoVinculadas, } from "../../service/api";
import SolicitudModal from "../../componentes/modal/solicitud/SolicitudModal";
import ModalMessage from "../../componentes/modal/ModalMessages/ModalMessages";
import { FaSyncAlt, FaTrashAlt } from "react-icons/fa";
import VincularModal from "../../componentes/modal/solicitud/VincularModal";
import VentasNoVinculadasModal from "../../componentes/modal/solicitud/VentasNoVinculadasModal";

export default class SolicitudesPage extends Component {


    state = {
        loading: false,
        fecha: localStorage.getItem("solicitudes_fecha") || this.toISODate(new Date()),
        solicitudes: [],
        sortKey: "idsolicitudfactura",
        sortDir: "desc",
        selectedRowId: null,

        verVincular: false,
        vincularSel: null,
        vincularLoading: false,
        ventasVinculadasArr: [],

        verVentasNoVinc: false,
        ventasNoVincLoading: false,
        ventasNoVincArr: [],
        banderaConfirm: "",
        ventaPendiente: null,

        q: "",
        verMensaje: false,
        modalMessage: "",
        solicitudBorrar: null,
        array_moneda: [],
        array_nacionalidad: [],
        verModal: false,
        modalMode: "create",
        solicitudSel: null,
        modalSaving: false,
    };


    componentDidMount() {
        this.setState({ loading: true });

        const datos = localStorage.getItem("datosm");
        if (!datos || datos === "") {
            window.location.href = "/";
            return;
        }

        this.getmonedas();
        this.fetchSolicitudes(this.state.fecha);
    }

    getmonedas = async () => {
        var resp = await getListaMoneda();

        if (resp && resp.code === 0) {
            const array_moneda = resp.data || [];
            this.setState({ array_moneda });
        }

        const respw = await getListaNacionalidad();

        if (respw && respw.code === 0) {
            this.setState({ array_nacionalidad: respw.data || [] });

        } else {
            this.setState({ array_nacionalidad: [] });
        }
    }

    refreshSolicitud = async () => {
        try {
            this.setState({ loading: true });
            await this.fetchSolicitudes(this.state.fecha);
        } catch (e) {
            //     toast.info("No fue posible refrescar");
        }
    };

    openVincular = async (s) => {
        this.setState(
            {
                verVincular: true,
                vincularSel: s,
                vincularLoading: true,
                ventasVinculadasArr: [],
            },
            async () => {
                await this.loadVentasVinculadas();
            }
        );
    };

    closeVincular = () => {
        if (this.state.vincularLoading || this.state.ventasNoVincLoading) return;
        this.setState({
            verVincular: false,
            vincularSel: null,
            ventasVinculadasArr: [],
            verVentasNoVinc: false,
            ventasNoVincArr: [],
        });
        this.fetchSolicitudes(this.state.fecha);

    };

    loadVentasVinculadas = async () => {
        const sel = this.state.vincularSel;
        if (!sel?.idsolicitudfactura) {
            this.setState({ vincularLoading: false });
            return;
        }

        try {
            this.setState({ vincularLoading: true });

            const resp = await solicitudDetalle(sel.idsolicitudfactura);

            //  token expirado
            if (resp?.code === 2003) {
                localStorage.clear();
                window.location.href = "/";
                return;
            }

            if (resp?.code !== 0) {
                toast.info(resp?.message || "No se pudo cargar el detalle.");
                this.setState({ ventasVinculadasArr: [] });
                return;
            }

            const arr = Array.isArray(resp?.data) ? resp.data : [];
            const detalle = arr[0] || null;

            const ventas = Array.isArray(detalle?.ventas) ? detalle.ventas : [];
            this.setState({
                vincularSel: detalle || sel,
                ventasVinculadasArr: ventas,
            });
        } catch (e) {
            toast.info("No se pudo cargar el detalle de la solicitud.");
            this.setState({ ventasVinculadasArr: [] });
        } finally {
            this.setState({ vincularLoading: false });
        }
    };


    // ===== Helpers =====
    toISODate(dateObj) {
        const y = dateObj.getFullYear();
        const m = String(dateObj.getMonth() + 1).padStart(2, "0");
        const d = String(dateObj.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
    }

    parseISOToDate = (iso) => {
        if (!iso) return new Date();
        const [y, m, d] = String(iso).split("-").map(Number);
        return new Date(y, (m || 1) - 1, d || 1);
    };

    money = (n) => {
        const val = Number(n || 0);
        return val.toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    // ===== API =====
    fetchSolicitudes = async (fechaISO) => {
        this.setState({ loading: true });


        try {
            const resp = await getListaSolicitud({ fecha: fechaISO }); // <-- o getListasolicitudes

            if (resp?.code === 0) {
                const raw = resp?.data || [];
                const arr = Array.isArray(raw) ? raw : raw?.data || [];
                this.setState({
                    solicitudes: arr,
                    loading: false,
                    selectedRowId: null,
                });
                return;
            }

            if (resp?.code === 2003) {
                this.setState({ loading: false });
                return;
            }

            this.setState({ loading: false });
            toast.info(resp?.message || "No se pudo cargar solicitudes.");
        } catch (e) {
            this.setState({ solicitudes: [], loading: false });
            toast.info("Error al cargar solicitudes.");
        }
    };

    // ===== UI handlers =====
    onChangeFecha = (dateObj) => {
        if (!dateObj) return;
        const fechaISO = this.toISODate(dateObj);
        localStorage.setItem("solicitudes_fecha", fechaISO);
        this.setState({ fecha: fechaISO }, () => this.fetchSolicitudes(fechaISO));
    };

    setHoy = () => {
        const hoyISO = this.toISODate(new Date());
        localStorage.setItem("solicitudes_fecha", hoyISO);
        this.setState({ fecha: hoyISO }, () => this.fetchSolicitudes(hoyISO));
    };

    onSelectRow = (rowId) => {
        this.setState((prev) => ({
            selectedRowId: prev.selectedRowId === rowId ? null : rowId,
        }));
    };

    openCreate = () => {
        this.setState({
            verModal: true,
            modalMode: "create",
            solicitudSel: null,
        });
    };

    openEdit = (s) => {
        this.setState({
            verModal: true,
            modalMode: "edit",
            solicitudSel: s,
            selectedRowId: String(s?.idsolicitudfactura),
        });
    };

    closeModal = () => {
        if (this.state.modalSaving) return;
        this.setState({ verModal: false, solicitudSel: null });
    };

    // ===== Sorting (simple) =====
    compareValues = (a, b) => {
        if (a == null) a = "";
        if (b == null) b = "";

        const na = Number(a);
        const nb = Number(b);

        const bothNumeric =
            !Number.isNaN(na) &&
            !Number.isNaN(nb) &&
            String(a).trim() !== "" &&
            String(b).trim() !== "";

        if (bothNumeric) return na - nb;
        return String(a).localeCompare(String(b), "es", { numeric: true, sensitivity: "base" });
    };

    getSortValue = (s, key) => {
        switch (key) {
            case "idsolicitudfactura":
                return s.idsolicitudfactura;
            case "idticket":
                return s.idticket;
            case "fecha_transito":
                return s.fecha_transito;
            case "nombre":
                return s.nombre;
            case "apellido":
                return s.apellido;
            case "nacionalidad":
                return s.nacionalidad;
            case "pasaporte":
                return s.pasaporte;
            case "via":
                return s.via;
            case "locacion":
                return s.locacion;
            case "cantidad":
                return s.cantidad;
            case "moneda":
                return s.moneda;
            case "carpeta":
                return s.carpeta;
            case "comentarios":
                return s.comentarios;
            case "estatus":
                return s.estatus;
            default:
                return "";
        }
    };

    onSort = (key) => {
        this.setState((prev) => {
            const same = prev.sortKey === key;
            const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
            return { sortKey: key, sortDir: nextDir };
        });
    };

    getSortedItems = () => {
        const { solicitudes, sortKey, sortDir } = this.state;

        return [...(solicitudes || [])].sort((sa, sb) => {
            const a = this.getSortValue(sa, sortKey);
            const b = this.getSortValue(sb, sortKey);
            const cmp = this.compareValues(a, b);
            return sortDir === "asc" ? cmp : -cmp;
        });
    };



    normalizeText = (v) =>
        String(v ?? "")
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

    getFilteredItems = (items) => {
        const q = this.normalizeText(this.state.q).trim();
        if (!q) return items;

        return (items || []).filter((s) => {
            const hay = [
                s?.idsolicitudfactura,
                s?.idticket,
                s?.fecha_transito,
                s?.nombre,
                s?.apellido,
                s?.nacionalidad,
                s?.pasaporte,
                s?.via,
                s?.locacion,
                s?.cantidad,
                s?.moneda,
                s?.comentarios,
                s?.carpeta,
                s?.estatus,
                s?.idestatus,
            ]
                .map(this.normalizeText)
                .join(" ");

            return hay.includes(q);
        });
    };


    // ===== Save (create/edit) =====
    onSaveSolicitud = async (payload, mode, original) => {
        // payload viene ya validado desde el modal (pero aquí igual cuidamos)
        this.setState({ modalSaving: true });

        try {
            let resp;

            if (mode === "create") {
                resp = await agregarSolicitud(payload);
            } else {
                if (typeof editarSolicitud !== "function") {
                  //  toast.info("No existe editarSolicitud en la API. Ajusta service/api.");
                    this.setState({ modalSaving: false });
                    return;
                }
                resp = await editarSolicitud(original?.idsolicitudfactura, payload);
            }

            if (resp?.code === 0) {
                toast.success(resp?.message || (mode === "create" ? "Solicitud agregada." : "Solicitud actualizada."));
                this.setState({ verModal: false, modalSaving: false, solicitudSel: null });
                this.fetchSolicitudes(this.state.fecha);
            } else {
                toast.info(`${resp?.message ?? "No se pudo guardar."}`);
                this.setState({ modalSaving: false });
                this.fetchSolicitudes(this.state.fecha);
            }
        } catch (e) {
            toast.info("Error al guardar la solicitud.");
            this.setState({ modalSaving: false });
        }
    };

    confirmEliminar = (s) => {
        // puedes mostrar ticket + nombre para que quede claro
        const label = `la solicitud #${s?.idsolicitudfactura} (Ticket ${s?.idticket} - ${s?.nombre ?? ""} ${s?.apellido ?? ""})`;

        this.setState({
            verMensaje: true,
            modalMessage: label,
            solicitudBorrar: s,
        });
    };

    confirmDesvincular = (venta) => {
        const s = this.state.vincularSel;
        const label = `¿Deseas desvincular la venta #${venta?.idticketpago} al ticket #${s?.idticket}?`;

        this.setState({
            verMensaje: true,
            modalMessage: label,
            banderaConfirm: "desvincular",
            ventaPendiente: venta,
        });
    };
    cerrarBorrar = async (response) => {
        // 0 = cancelar
        if (response === 0) {
            this.setState({
                verMensaje: false,
                modalMessage: "",
                solicitudBorrar: null,
                banderaConfirm: "",
                ventaPendiente: null,
            });
            return;
        }

        //  CASO: DESVINCULAR
        if (this.state.banderaConfirm === "desvincular") {
            const s = this.state.vincularSel;
            const v = this.state.ventaPendiente;

            // console.log("Desvincular - solicitud:", s);
            //// consolelog("Desvincular - venta:", v);
            // cerramos confirmación (y limpiamos bandera)
            this.setState({ verMensaje: false, modalMessage: "" });

            if (!s?.idsolicitudfactura || !v?.idticketpago) {
                toast.info("No se encontró información para desvincular.");
                this.setState({ banderaConfirm: "", ventaPendiente: null });
                return;
            }

            try {
                this.setState({ vincularLoading: true });

                const resp = await apidesvincular(s.idsolicitudfactura, v.idticketpago);

                if (resp?.code === 0 || resp?.success) {
                    toast.success(resp?.message || "Venta desvinculada.");
                    await this.loadVentasVinculadas();
                } else {
                    toast.info(resp?.message || "No se pudo desvincular.");
                }
            } catch (e) {
                toast.info("Error al desvincular.");
            } finally {
                this.setState({
                    vincularLoading: false,
                    banderaConfirm: "",
                    ventaPendiente: null,
                });
            }
            return;
        }

        //  CASO: ELIMINAR SOLICITUD
        const s = this.state.solicitudBorrar;

        if (!s?.idsolicitudfactura) {
            this.setState({ verMensaje: false, modalMessage: "", solicitudBorrar: null });
            toast.info("No se encontró la solicitud a eliminar.");
            return;
        }

        try {
            this.setState({
                loading: true,
                verMensaje: false,
                banderaConfirm: "",
                ventaPendiente: null,
            });

            const resp = await eliminarSolicitud(s.idsolicitudfactura);

            if (resp?.code === 0) {
                toast.success(resp?.message || "Solicitud eliminada.");
                this.setState({ solicitudBorrar: null, loading: false, selectedRowId: null });
                this.fetchSolicitudes(this.state.fecha);
            } else {
                toast.info(`${resp?.message ?? "No se pudo eliminar."}`);
                this.setState({ solicitudBorrar: null });
                this.fetchSolicitudes(this.state.fecha);
            }
        } catch (e) {
            this.setState({ solicitudBorrar: null });
            toast.info("Error al eliminar la solicitud.");
            this.fetchSolicitudes(this.state.fecha);
        }
    };

    truncateText = (text, max = 40) => {
        const t = String(text ?? "").trim();
        if (t.length <= max) return t;
        return t.slice(0, max) + "...";
    };



    addVentaToSolicitud = async (venta) => {
        const s = this.state.vincularSel;
        if (!s?.idsolicitudfactura || !venta?.idticketpago) return;

        try {
            this.setState({ ventasNoVincLoading: true });

            const resp = await apiVincular(s.idsolicitudfactura, venta.idticketpago);

            if (resp?.code === 0 || resp?.success || resp?.ok) {
                toast.success(resp?.message || "Venta vinculada.");
                //  cerramos selector y recargamos vinculadas
                this.setState({ verVentasNoVinc: false, ventasNoVincArr: [] }, this.loadVentasVinculadas);
            } else {
                toast.info(resp?.message || "No se pudo vincular.");
            }
        } catch (e) {
            toast.info("Error al vincular.");
        } finally {
            this.setState({ ventasNoVincLoading: false });
        }
    };

    openVentasNoVinculadas = async () => {
        const s = this.state.vincularSel;
        const idticket = s?.idticket;

     
        try {
            this.setState({ verVentasNoVinc: true, ventasNoVincLoading: true, ventasNoVincArr: [] });

            const resp = await ventasListaNoVinculadas(idticket);
            const arr = resp?.data || resp || [];
            this.setState({ ventasNoVincArr: Array.isArray(arr) ? arr : [] });
        } catch (e) {
            toast.info("No se pudo cargar ventas para vincular.");
            this.setState({ ventasNoVincArr: [] });
        } finally {
            this.setState({ ventasNoVincLoading: false });
        }
    };

    closeVentasNoVinc = () => {
        if (this.state.ventasNoVincLoading) return;
        this.setState({ verVentasNoVinc: false, ventasNoVincArr: [] });
    };

    getRole = () => {
        try {
            const raw = localStorage.getItem("sharem");
            const j = raw ? JSON.parse(raw) : {};
            return String(j?.role || "").trim().toLowerCase();
        } catch (e) {
            return "";
        }
    };

    canVincular = () => {
        const r = this.getRole();
        return r === "administrador" || r === "contador";
    };

    getEstatusClass = (id) => {
        const map = {
            1: "none",
            4: "green",
            5: "warn",
            3: "blue",
        };
        return map[Number(id)] || "none";
    };


    render() {
        const { loading, fecha, selectedRowId, verModal, modalMode, solicitudSel, modalSaving, array_moneda } = this.state;
        const sorted = this.getSortedItems();
        const items = this.getFilteredItems(sorted);

        return (
            <div className="v-page">
                <Navbar />

                {loading ? <SpinnerModal tipo="full" show={loading} /> : null}

                <ModalMessage
                    show={this.state.verMensaje}
                    titulo="Confirmar"
                    mensaje={this.state.modalMessage}
                    bandera={this.state.banderaConfirm || "eliminar"}
                    cerrarBorrar={this.cerrarBorrar}
                />

                <SolicitudModal
                    show={verModal}
                    mode={modalMode}
                    solicitud={solicitudSel}
                    loading={modalSaving}
                    moneda={array_moneda}
                    onClose={this.closeModal}
                    onSave={this.onSaveSolicitud} 
                    array_nacionalidad={this.state.array_nacionalidad}
                    fechaPage={this.state.fecha}
                />
                <VincularModal
                    show={this.state.verVincular}
                    onClose={this.closeVincular}
                    solicitud={this.state.vincularSel}              //  solicitud con ventas y datos
                    loading={this.state.vincularLoading}
                    ventasVinculadas={this.state.ventasVinculadasArr} //  solo ventas
                    onClickAgregar={this.openVentasNoVinculadas}
                    onDesvincular={this.confirmDesvincular} 
                />

                <VentasNoVinculadasModal
                    show={this.state.verVentasNoVinc}
                    onClose={this.closeVentasNoVinc}
                    loading={this.state.ventasNoVincLoading}
                    ventas={this.state.ventasNoVincArr}
                    onAddVenta={this.addVentaToSolicitud}
                />

                <div className="so-shell">
                    <div className="v-top">
                        <h1 className="v-title">Solicitudes</h1>

                        <div className="v-actions">


                            <div className="so-search">
                                <span className="so-ico" aria-hidden="true">🔎</span>
                                <input
                                    type="text"
                                    value={this.state.q}
                                    onChange={(e) => this.setState({ q: e.target.value, selectedRowId: null })}
                                    placeholder="Buscar ticket, nombre..."
                                    disabled={loading}
                                />
                                {String(this.state.q || "").length > 0 && (
                                    <button
                                        type="button"
                                        className="so-clear"
                                        onClick={() => this.setState({ q: "", selectedRowId: null })}
                                        disabled={loading}
                                        aria-label="Limpiar búsqueda"
                                        title="Limpiar"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>



                            <div className="v-date">
                                <button
                                    type="button"
                                    className="v-btnHoy"
                                    onClick={this.setHoy}
                                    disabled={loading}
                                    title="Fecha actual"
                                >
                                    Hoy
                                </button>

                                <DatePicker
                                    id="ventas-date"
                                    value={this.parseISOToDate(fecha)}
                                    onChange={this.onChangeFecha}
                                    formatStyle="large"
                                    placeholder="Selecciona fecha"
                                />

                                <button
                                    type="button"
                                    className="v-btnRefresh"
                                    onClick={this.refreshSolicitud}
                                    disabled={loading}
                                >
                                    <FaSyncAlt />
                                </button>
                            </div>


                            <button className="v-btn" onClick={this.openCreate} disabled={loading}>
                                AGREGAR SOLICITUD
                            </button>
                        </div>
                    </div>

                    <div className="vard">
                        <div className="v-card">
                            <div className="v-tableWrap">
                                <table className="v-table v-table--sol">
                                    <thead>
                                        <tr>
                                            <th className="v-thSort" onClick={() => this.onSort("idticket")}>Ticket</th>
                                            <th className="v-thSort" onClick={() => this.onSort("fecha_transito")}>Fecha tránsito</th>
                                            <th className="v-thSort" onClick={() => this.onSort("nombre")}>Nombre</th>
                                            <th className="v-thSort" onClick={() => this.onSort("apellido")}>Apellido</th>
                                            <th className="v-thSort" onClick={() => this.onSort("nacionalidad")}>Nacionalidad</th>
                                            <th className="v-thSort" onClick={() => this.onSort("pasaporte")}>Pasaporte</th>
                                            <th className="v-thSort" onClick={() => this.onSort("via")}>Vía</th>
                                            <th className="v-thSort" onClick={() => this.onSort("locacion")}>Locación</th>
                                            <th className="v-thSort v-num" onClick={() => this.onSort("cantidad")}>Cantidad</th>
                                            <th className="v-thSort" onClick={() => this.onSort("moneda")}>Moneda</th>
                                            <th className="v-thSort  v-col-comentarios" onClick={() => this.onSort("comentarios")}>Comentarios</th>
                                            <th className="v-thSort" onClick={() => this.onSort("carpeta")}>Carpeta</th>
                                            <th className="v-thSort" onClick={() => this.onSort("estatus")}>Estatus</th>
                                            <th>Gestión</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr>
                                                <td colSpan="13" className="v-empty">
                                                    {this.state.q ? "Sin resultados para la búsqueda" : "No hay registros disponibles"}
                                                </td>                                            </tr>
                                        ) : (
                                            items.map((s, idx) => {
                                                const rowId = String(s?.idsolicitudfactura ?? idx);
                                                const isActive = selectedRowId === rowId;

                                                return (
                                                    <tr
                                                        key={`${rowId}-${idx}`}
                                                        className={isActive ? "row-active" : ""}
                                                        onClick={() => this.onSelectRow(rowId)}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <td className="v-mono">{s.idticket}</td>
                                                        <td className="v-mono">{s.fecha_transito || ""}</td>
                                                        <td>{s.nombre || ""}</td>
                                                        <td>{s.apellido || ""}</td>
                                                        <td className="v-mono">{s.nacionalidad || ""}</td>
                                                        <td className="v-mono">{s.pasaporte || ""}</td>
                                                        <td className="v-mono">{s.via || ""}</td>
                                                        <td>{s.locacion || ""}</td>
                                                        <td className="v-num">{this.money(s.cantidad)}</td>
                                                        <td className="v-mono">{s.moneda || ""}</td>
                                                        <td
                                                            className="v-mono  v-col-comentarios"
                                                            title={s.comentarios || ""}
                                                        >
                                                            {this.truncateText(s.comentarios, 30)}
                                                        </td>
                                                        <td className="v-mono">
                                                            {(() => {
                                                                const carpetaRaw = String(s?.carpeta ?? "").trim();
                                                                if (!carpetaRaw) return "";

                                                                const url = /^https?:\/\//i.test(carpetaRaw) ? carpetaRaw : `https://${carpetaRaw}`;

                                                                return (
                                                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>


                                                                        <button
                                                                            type="button"
                                                                            className="v-miniBtn"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                window.open(url, "_blank", "noopener,noreferrer");
                                                                            }}
                                                                            title="Abrir carpeta"
                                                                        >
                                                                            Ver
                                                                        </button>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </td>
                                                  

                                                        <td>
                                                            <span className={`v-badge ${this.getEstatusClass(s.idestatus)}`}>
                                                                {s.estatus ?? ""}
                                                            </span>
                                                        </td>

                                                        <td onClick={(e) => e.stopPropagation()}>
                                                            <div className="so-actions">
                                                                <div className="so-actions__top">
                                                                    <button
                                                                        type="button"
                                                                        className="v-miniBtn"
                                                                        onClick={() => this.openEdit(s)}
                                                                        disabled={loading}
                                                                    >
                                                                        Editar
                                                                    </button>

                                                                    <button
                                                                        type="button"
                                                                        className="so-iconBtn"
                                                                        onClick={() => this.confirmEliminar(s)}
                                                                        disabled={loading}
                                                                        title="Eliminar"
                                                                        aria-label="Eliminar"
                                                                    >
                                                                        <FaTrashAlt className="icodelates" />
                                                                    </button>
                                                                </div>

                                                                {this.canVincular() && (
                                                                    <button
                                                                        type="button"
                                                                        className="so-linkBtn"
                                                                        onClick={() => this.openVincular(s)}
                                                                        disabled={loading}
                                                                        title="Vincular"
                                                                    >
                                                                        Vincular
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
